<div class="main-header" *ngIf="displayHeader">
    <div class="products-header d-flex flex-column"
        *ngIf="currentRoute=='/shop/machine-prod-items' || isRouteStartsWith('/shop/mfg/')">
        <div class="machine-prods d-flex justify-content-between">
            <div class="d-flex w-100 align-self-center justify-content-center">
                <div class="d-flex flex-column">
                    <span class="selected-mac pt-2">{{genieName}} ({{this.itemslength}})</span>
                    <span class="cld-status " [ngClass]="{'text-green': cloudStatus=='Connected',
                    'text-red': cloudStatus=='Disconnected'}">{{cloudStatus}}</span>
                </div>

                <div class="text-white pl-1" style="margin-top: .35rem;" (click)="openPopup(machPopup)">
                    <img [src]="machDownArrowIcon" class="text-white" style="width: 15px; margin-bottom: .5rem;" alt="">
                    <!-- popover code -->

                </div>
            </div>
            <div class="scan-header ml-auto align-self-center pr-2" (click)="OnScanPress(qrScannerModal)">
                <img [src]="qrcodeImg" alt="">
            </div>
        </div>


        <!-- search -->
        <div class="switch">
            <div class="wallet-bal text-white font-weight-bold w-100 align-self-center" *ngIf="!isSearchActive">
                Wallet Balance: <span class="wallet-amt">{{walletBal |
                    currency:'INR':'symbol-narrow':'1.0-2'}}</span>
                <i class="fa fa-plus ml-2" [routerLink]="['/shop/wallet']" style="color: white;"></i>
            </div>
            <div class="search-container d-flex" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()"
                (click)="onContainerClick()">
                <i class="fa fa-search  default-search-icon ml-auto d-flex align-self-center" style="color: white;"></i>
                <input type="text" class="search-field" (focus)="onFocus()" placeholder="Search products..."
                    [(ngModel)]="searchProdTerm" (input)="onProdSearchChange($event.target.value)">
                <i class="fa fa-search search-icon" *ngIf="isSearchActive"></i>
                <i class="fa fa-close close-icon" (click)="onClearSearch()" *ngIf=" searchProdTerm.length>0"></i>

            </div>
            <!-- switch button -->
            <!-- <img [src]="setSelectedView ? listFill : listIcon" class="listicon"  (click)="onSubcatView()"> -->
            <!-- <i class="fa fa-server listicon" [ngClass]="{'orange': setSelectedView, 'white': !setSelectedView}" (click)="onSubcatView()"></i>  -->
            <i class="fa fa-server" [ngClass]="{'rackcolor':!setSelectedView, 'listicon':setSelectedView}"
                (click)="onSubcatView()"></i>

        </div>
    </div>
    <!-- mfgcart code starts -->
    <div class="mfg-cart cart-head w-100 d-flex" *ngIf="currentRoute=='/shop/mfg-cart'">
        <span class="text-white cart-heading">Cart Items</span>
        <span class="ml-auto pr-2" (click)="OnClosePress()"><i class="fa fa-close fa-2x text-white"></i></span>
    </div>
    <!-- myaccount code starts -->
    <div class="mfg-cart cart-head" *ngIf="currentRoute =='/shop/myaccount' || currentRoute =='/shop/myorders'">
        <div class="useravtar">
            <span class="text-white cart-heading">Hello {{user.userName}}!</span>
            <img src="../../../../assets/images/genieImages/avtar.png" class="avtarimage">
        </div>

        <div class="buttons">
            <button class="orders" [class.selected-button]="(dataService.selectedButton$ | async) === 'orders'"
                (click)="onOrders()">My Orders</button>
            <button class="profile" [class.selected-profile]="(dataService.selectedButton$ | async) === 'profile'"
                (click)="onProfile()">My Profile</button>
        </div>
    </div>

</div>
<!-- popup machines -->
<ng-template #machPopup>
    <div class="modal-header">
        <h5 class="modal-title f-w-600" id="exampleModalLabel">Select Machines</h5>
        <button type="button" class="close" aria-label="Close" (click)="modalReference.close()">
            <span aria-hidden="true">&times;</span>
        </button>

    </div>
    <div class="modal-body overflow-auto">
        <div class="vending-machines">
            <div class="vending-card" *ngFor="let machine of allGeniesList" (click)="onMachineSelect(machine)">
                <div class="d-flex w-100 ml-auto">
                    <i class="fa fa-heart ml-auto pt-1 pr-1" (click)="onAddtoFav($event,machine)" style="color: red;"
                        *ngIf="machine.favGenie"></i>
                    <i class="fa fa-heart-o ml-auto pt-1 pr-1" *ngIf="!machine.favGenie"
                        (click)="onAddtoFav($event,machine)"></i>
                </div>
                <img [src]="machine.imageFile" class="vendingImg" alt="Genie Image">
                <span class="mach-text pl-2 ">{{machine.name}}</span>

                <span class=" pl-1 pb-1 cld-status"
                    [ngClass]="{'text-green': machine.cloudStatus=='Connected',
                                                 'text-red': machine.cloudStatus=='Disconnected'}">{{machine.cloudStatus}}</span>
                <!-- <span class="distance pl-2 pb-2">{{machine?.distanceInKm || 0}} KM Away</span>
              <div class="d-flex pl-2 pb-2 align-items-center">
                <i class="fa fa-map-marker map-icon"></i>
                <a class="location pl-2" (click)="onLocationPress(machine,$event)">
        
                  {{ machine?.address.length > 15 ? machine?.address.slice(0, 20) + '...' :
                  machine.address
                  }}
                </a>
        
              </div> -->


            </div>

        </div>

    </div>

</ng-template>
<!-- qr code scanning for machines -->
<ng-template #qrScannerModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Scan QR Code</h5>
        <button type="button" class="close" (click)="onClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <mat-slide-toggle (click)="toggleTorch()">Torch: {{torchEnabled}}</mat-slide-toggle>

        <div class="form-group mt-2" *ngIf="currentDevice">
            <label for="" class="mb-1">Choose Camera</label>
            <select class="form-control mb-1" (change)="onDeviceSelectChange($event.target.value)">
                <option value="" [selected]="!currentDevice">No Device Selected</option>
                <option *ngFor="let device of availableDevices" [value]="device.deviceId"
                    [selected]="currentDevice && device.deviceId === currentDevice.deviceId">{{device.label}}</option>
            </select>
        </div>

        <!-- QR scanner component here -->
        <div class="scanner-container absolute inset-0 flex flex-col min-w-0 overflow-hidden">

            <zxing-scanner (scanSuccess)="onScanSuccess($event)" [torch]="torchEnabled" [(device)]="currentDevice"
                [tryHarder]="tryHarder" (permissionResponse)="onHasPermission($event)"
                (camerasFound)="onCamerasFound($event)" [formats]="allowedFormats"
                (torchCompatible)="onTorchCompatible($event)"></zxing-scanner>


            <div *ngIf="isContainerVisible" class="rectangle-overlay">
                <div class="line" [style.top.%]="linePosition"></div>
            </div>
        </div>
    </div>

</ng-template>